import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Youtube } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { getNavigationRoutes } from '../../config/routes';

export default function Footer() {
  const { t } = useLanguage();

  const navigationRoutes = getNavigationRoutes();
  const navigation = navigationRoutes.map((route) => ({
    name: t(`nav_${route.name}`),
    href: route.path === '/' ? '/' : route.path,
  }));

  return (
    <footer className="bg-graweo-chocolate text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-graweo-terra rounded-xl flex items-center justify-center">
                <Heart className="w-5 h-5 text-white" fill="currentColor" />
              </div>
              <span className="text-xl font-bold font-manrope">GRAWEO</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4 font-manrope">{t('footer_links')}</h3>
            <div className="flex flex-col gap-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="text-white/80 hover:text-graweo-terra text-sm transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4 font-manrope">{t('footer_contact')}</h3>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:info@graweo.org"
                className="flex items-center gap-2 text-white/80 hover:text-graweo-terra text-sm transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>info@graweo.org</span>
              </a>
              <a
                href="https://youtube.com/@graweo"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/80 hover:text-graweo-terra text-sm transition-colors"
              >
                <Youtube className="w-4 h-4" />
                <span>@graweo</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/60">
            © {new Date().getFullYear()} GRAWEO. {t('footer_rights')}
          </p>
          <Link
            to="/gdpr-policy"
            className="text-sm text-white/60 hover:text-graweo-terra transition-colors"
          >
            {t('footer_gdpr_link')}
          </Link>
        </div>
      </div>
    </footer>
  );
}